export default __webpack_public_path__ + "static/media/add_customer.58c9fe04.svg";